import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface EquityInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function EquityInternalControls({
  onBack,
  setActiveSection,
  controlsListSection,
}: EquityInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Equity"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}
